import React from 'react';
import { Link } from 'react-router-dom';

// Единый список юридических страниц: футеры лендинга, блога, бесплатных
// инструментов и самих документов берут ссылки отсюда.
export const LEGAL_LINKS = [
  { to: '/offer', label: 'Публичная оферта', short: 'Оферта' },
  { to: '/privacy', label: 'Политика конфиденциальности', short: 'Конфиденциальность' },
  { to: '/privacy-consent', label: 'Согласие на обработку персональных данных', short: 'Согласие на обработку ПД' },
  { to: '/ads-consent', label: 'Согласие на рекламную рассылку', short: 'Согласие на рекламу' },
  { to: '/it-company-info', label: 'Сведения об организации', short: 'Об организации' },
];

export function LegalLinkItems({ short = false, as: Wrapper = null }) {
  return LEGAL_LINKS.map((item) => {
    const link = <Link key={item.to} to={item.to}>{short ? item.short : item.label}</Link>;
    return Wrapper ? <Wrapper key={item.to}>{link}</Wrapper> : link;
  });
}
